import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=4d63020e&"
import script from "./Ticket.vue?vue&type=script&lang=ts&"
export * from "./Ticket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports